import {Component, Input, OnInit} from '@angular/core';
import {QuestionModel} from '../../../../../models/questions/question.model';
import {DoubleAdditionModel} from '../../../../../models/questions/subModels/doubleAddition.model';
import {Enums} from '../../../../../models/extensions/enums';

@Component({
  selector: 'app-evo-double-subtraction',
  templateUrl: './evo-double-subtraction.component.html',
  styleUrls: ['./evo-double-subtraction.component.css']
})
export class EvoDoubleSubtractionComponent implements OnInit {

  Enums = Enums;
  @Input() question: QuestionModel = new DoubleAdditionModel();

  constructor() { }

  ngOnInit() {
  }

  castedQuestion(): DoubleAdditionModel {

    return <DoubleAdditionModel>this.question;
  }

  getOutcomeString(): string {

    let minOutcomeOne = this.castedQuestion().model.firstRange.minValue() - this.castedQuestion().model.secondRange.maxValue();
    let maxOutcomeOne = this.castedQuestion().model.firstRange.maxValue() - this.castedQuestion().model.secondRange.minValue();

    if (this.castedQuestion().model.firstMinOutcome !== null) {

      minOutcomeOne = this.castedQuestion().model.firstMinOutcome;

    }

    if (this.castedQuestion().model.firstMaxOutcome !== null) {

      maxOutcomeOne = this.castedQuestion().model.firstMaxOutcome;

    }

    let outcomePartOne = '[' + minOutcomeOne.toString(10) + ', ';
    outcomePartOne += maxOutcomeOne + ']';

    let minOutcomeTwo = minOutcomeOne - this.castedQuestion().model.thirdRange.maxValue();
    let maxOutcomeTwo = maxOutcomeOne - this.castedQuestion().model.thirdRange.minValue();

    if (this.castedQuestion().model.secondMinOutcome !== null) {
      minOutcomeTwo = this.castedQuestion().model.secondMinOutcome;
    }

    if (this.castedQuestion().model.secondMaxOutcome !== null) {
      maxOutcomeTwo = this.castedQuestion().model.secondMaxOutcome;
    }

    let outcomePartTwo = '[' + minOutcomeTwo + ', ';
    outcomePartTwo += maxOutcomeTwo + ']';

    return outcomePartOne + ' - [' + this.castedQuestion().model.thirdRange.getRange()
      + '] = ' + outcomePartTwo;
  }

  showQuestion(): boolean {

    if (this.question) {
      if (this.question.subCategory === Enums.QuestionSubcategories.doubleSubtraction) {
        return true;
      }
    }

    return false;
  }

}
